// Common current formatter
export const currencyFormatter = (amount: any) => {
  if (amount) {
    const amountVal = Number(amount);
    const format = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return format.format(amountVal);
  }
  return '$0.00';
};
